import { Action } from '@/_core/fluxstore/types';
import { StorymapState, Subtask } from '../types';
import { useStorymapStore } from '../useModule';
import { queryExecutor } from '@/_core/cqrs';
import {
    PublishedStorymapPreloadCardDescriptionsQuery,
    StorymapPreloadCardDescriptionsQuery,
    StorymapPreloadCardDescriptionsQueryResult,
} from '../../api/queries';
import { bugsnagNotify } from '@/_core/utils/bugsnag';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class PreloadCardDescriptions extends Action<StorymapState> {
    public static ACTION_TYPE = 'PreloadCardDescriptions';
    public _res: StorymapPreloadCardDescriptionsQueryResult;

    public constructor(public storymapSlug: string, public isCurrent: () => boolean = () => true) {
        super(PreloadCardDescriptions.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: PreloadCardDescriptions): Promise<boolean> => {
    const query = state.isPublishedRecipient
        ? new PublishedStorymapPreloadCardDescriptionsQuery(state.publishedAccessKind, state.publishedAccessKey)
        : new StorymapPreloadCardDescriptionsQuery(action.storymapSlug);

    const res = await queryExecutor.executeQuery(query, (error) => {
        if (!action.isCurrent()) return { isHandled: true, result: null };
        error.message = 'Handled: ' + (error.message ?? '(no message)');
        bugsnagNotify(error);

        return { isHandled: true, result: null };
    });

    if (!action.isCurrent()) return false;
    action._res = res;
    return true;
};

const reducer = (state: StorymapState, action: PreloadCardDescriptions): void => {
    if (!action.isCurrent() || !action._res) {
        return;
    }

    const subtaskMap = new Map<string, Subtask>();
    state.subtasks.forEach((subtask) => {
        subtaskMap.set(subtask.id, subtask);
    });

    for (const [id, description] of Object.entries(action._res.CardDescriptions)) {
        const subtask = subtaskMap.get(id);
        // A full description loaded by card details wins over the shortened preload (R18).
        if (subtask && !subtask.isFullDescriptionLoaded) {
            subtask.description = description;
        }
    }
};

//@ts-ignore
registerMiddleware(PreloadCardDescriptions.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(PreloadCardDescriptions.ACTION_TYPE, reducer);
